import { SidebarBoxKey } from 'AdmissionsGuidance/StudentDashboard.types';
import { useTranslation } from 'react-i18next';
import { memo, useMemo } from 'react';
import { useNavigationHelper } from 'FrontRoyalAngular';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';
import { BasicDesktopBox } from '../../BasicDesktopBox';

export function DiplomaFramesBoxComponent() {
    const { loadUrl } = useNavigationHelper();
    const { t } = useTranslation('back_royal', { keyPrefix: 'diplomaFramesBox' });
    const buttons = useMemo<ButtonConfig[]>(
        () => [
            {
                id: 'button_browse_frames',
                text: t('buttonBrowseFrames'),
                onPress: () => loadUrl('/links/diploma/frames', '_blank'),
            },
        ],
        [t, loadUrl],
    );
    return <DiplomaFramesBoxPresentation buttons={buttons} />;
}

function DiplomaFramesBoxPresentation({ buttons }: { buttons: ButtonConfig[] }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'diplomaFramesBox' });
    return (
        <BasicDesktopBox boxKey={SidebarBoxKey.diploma_frames} headerText={t('heading')} buttons={buttons}>
            {t('content')}
        </BasicDesktopBox>
    );
}

export const DiplomaFramesBox = memo(DiplomaFramesBoxComponent) as unknown as typeof DiplomaFramesBoxComponent;
